import React from 'react'
import { Link } from "react-router-dom"
import P1 from './P1'
import P2 from './P2'
import Footer from './Footer'
import { saladsList } from '../data/Data'
import img6 from "../../Images/p-6.jpg"

const Salads = () => {
  return (
    <>
      <P1 topimg={img6} topText="Salads" />

      <div className="container dishTypeUniversal">

        <div className="dishTypeHigh">
          <ul className='dishTypeHigh-inner'>
            <li >
              <Link to="/pizza" className= 'inner-link'>PIZZA</Link>
            </li>
            <li>
              <Link to="/salads" className='active inner-link'>SALADS</Link>
            </li>
            <li>
              <Link to="/soups" className='inner-link'>SOUPS</Link>
            </li>
            <li>
              <Link to="/desserts" className='inner-link'>DESSERTS</Link>
            </li>
            <li>
              <Link to="/drinks" className='inner-link'>DRINKS</Link>
            </li>
          </ul>
        </div>

      <div className='content grid3 chefRecom'>
        {saladsList.map((items) => (
    
         <P2 Id={items.id} Cover={items.cover} Price={items.price} Name={items.name} About={items.about} Stars={items.stars} key={items.id}/>
    
        ))};
      </div>


    </div>
      <Footer />
    </>
  )
}

export default Salads
